<template>
    <div id="wufu2020" class="wufu2020">
        <span>打开支付宝AR扫一扫，以下图片每天可领取一张福卡</span>
        <div class="image-lists">
            <div class="image" v-for="(item, index) in imageList" :key="index">
                <img :src="item.src" :alt="item.alt">
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'wufu2020',
    metaInfo: {// vue-meta设置页面的title和meta信息
        title: '2020年支付宝五福',
        meta: [
            {
                name: 'keywords',
                content: '1030官网, 1030design, 1030, 1030设计, 原创设计'
            }
        ]
    },
    data () {
        return {
            imageList: [
                {
                    src: require('../../assets/images/2020wufu/马云福.jpg'),
                    alt: '马云福'
                },
                {
                    src: require('../../assets/images/2020wufu/starbucks.jpg'),
                    alt: 'starbucks'
                },
                {
                    src: require('../../assets/images/2020wufu/中国移动.jpg'),
                    alt: '中国移动'
                },
                {
                    src: require('../../assets/images/2020wufu/可口可乐.jpg'),
                    alt: '可口可乐'
                },
                {
                    src: require('../../assets/images/2020wufu/安慕希.jpg'),
                    alt: '安慕希'
                },
                {
                    src: require('../../assets/images/2020wufu/航天科工.jpg'),
                    alt: '航天科工'
                }
            ]
        }
    }
}
</script>
<style lang="scss" type="text/scss" scoped>
.wufu2020 {
    width: 600px;
    max-width: 100%;
    margin: 20px auto;
    padding: 0 16px;
    box-sizing: border-box;
    text-align: center;

    .image-lists {
        width: 100%;

        .image {
            margin-top: 16px;
        }

        .image img{
            width: 100%;
        }
    }
}

</style>
